import '@babel/polyfill';
import React from 'react';
import { I18nSetup } from '@cashfree-intl/coherent';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import TagManager from 'react-gtm-module';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import _get from 'lodash/get';

import errorMessages from '../externaliseError/validationErrors.json';

import PackageJson from '/package.json';

// Providers
import NotificationProvider from 'providers/NotificationProvider';

// Constants
import { PROD } from 'constants/common';

// Containers
import App from 'containers/App';

// Stores
import configureStore from 'redux/configureStore';

const store = configureStore({});

const root = createRoot(document.getElementById('app'));

const basename = process.env.PUBLIC_PATH;
const env = process.env.NODE_ENV;
let ignoreAPIError = false;

const render = () => {
  root.render(
    <BrowserRouter basename={basename.slice(0, basename.length - 1)}>
      <I18nSetup messages={{ en: errorMessages }}>
        <Provider store={store}>
          <NotificationProvider>
            <App />
          </NotificationProvider>
        </Provider>
      </I18nSetup>
    </BrowserRouter>,
  );
};

if (module.hot) {
  module.hot.accept(['containers/App'], () => {
    root.unmount();
    render();
  });
}

if (env === PROD) {
  TagManager.initialize({
    gtmId: process.env.GTM_ID,
  });
}

if (env === (PROD || 'gamma')) {
  Sentry.init({
    dsn:
      'https://d845e8a714e0e517f0f0e7659b4f2c7f@o330525.ingest.sentry.io/4506025870295040',
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 0.5,
    release: `vs-webapp-${PackageJson.version}`,
    environment: env,
    ignoreErrors: [
      'Unauthorized',
      /401/,
      /(bot\/bot)/,
      /Cannot read properties of null (reading 'style')/,
      /Loading chunk/,
    ],
    beforeBreadcrumb: response => {
      const isXhr = _get(response, 'category') === 'xhr';
      if (!ignoreAPIError && isXhr) {
        const statusCode = [401, 404].includes(
          _get(response, 'data.status_code', 200),
        );

        if (isXhr && statusCode) {
          ignoreAPIError = true;
        }
      }

      return response;
    },
    beforeSend: event => {
      if (event.tags && _get(event.tags, 'priority') === 'p0') {
        return event;
      }

      if (ignoreAPIError) {
        ignoreAPIError = false;
        return null;
      }
      ignoreAPIError = false;
      return event;
    },
  });
}

render();
